module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921132334_T.b34c7625.jpg";